import { Component, OnInit, ViewChild } from '@angular/core';
import { IonReorderGroup, IonicModule } from '@ionic/angular';
import { FirebaseService } from 'src/app/services/global/firebase/firebase.service';
import { ItemReorderEventDetail } from '@ionic/core';

import { BookmarksService } from './services/bookmarks.service';
import { GlobalService } from 'src/app/services/global/global.service';
import { LangType } from 'src/app/services/config/lang-type.service';
import { Indexing } from 'src/app/services/bible/indexing.service';
import { PremiumOptionsService } from '../premium/services/premium-options.service';
import { PremiumService } from '../premium/services/premium.service';
import { StateService } from 'src/app/services/config/state.service';
import { ActivatedRoute } from '@angular/router';
import { UserStore } from "../../services/global/user/user.store";
import { ToggleMenuBackBtnComponent } from '../../components/header/toggle-menu-back-btn/toggle-menu-back-btn.component';
import { TitleFirstWordChangeComponent } from '../../components/header/title-first-word-change/title-first-word-change.component';
import { NgIf, NgFor } from '@angular/common';
import { BigMsgDialogComponent } from '../../components/dialogs/big-msg-dialog/big-msg-dialog.component';
import { BookmarkItemComponent } from '../home/bookmarks-slider/bookmark-item/bookmark-item.component';

@Component({
    selector: 'app-bookmarks',
    templateUrl: './bookmarks.page.html',
    styleUrls: ['./bookmarks.page.scss'],
    standalone: true,
    imports: [
        IonicModule,
        ToggleMenuBackBtnComponent,
        TitleFirstWordChangeComponent,
        NgIf,
        BigMsgDialogComponent,
        NgFor,
        BookmarkItemComponent,
    ],
})
export class BookmarksPage implements OnInit {
  @ViewChild(IonReorderGroup) reorderGroup: IonReorderGroup;

  constructor(private bookmarksService: BookmarksService, private firebase: FirebaseService, private global: GlobalService, private langType: LangType, private indexing: Indexing, 
              public premiumOptions: PremiumOptionsService, public premium: PremiumService, private state: StateService, private activeRoute: ActivatedRoute, private userStore: UserStore) {
    this.state.setState(this.activeRoute.snapshot.params);
  }

  ngOnInit() {
  }

  ionViewWillEnter() {
    this.firebase.logEvent('page_bookmarks');
  }
  
  get bookmarks() {
    return this.bookmarksService.bookmarks;
  }
  
  /*
   * reorder list
   */
  public doReorder(ev: CustomEvent<ItemReorderEventDetail>) {
    this.bookmarksService.splice(ev.detail.from, ev.detail.to);
    ev.detail.complete();
  }
  
  get isPremium() {
    return this.userStore.hasPremiumAccess;
  }

  get hasFreePremiumGrant() {
    return this.userStore.hasFreePremiumGrant;
  }
}
